import React from "react";
import styles from "./Last.module.css";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaTwitch } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";

function Last() {
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.last} id="contact-us">
      <div className={styles.background}>
        <div className={styles.locations}>
          <div className={styles.new}>
            <div className={styles.locationBlock}>
              <h4>CALIFORNIA</h4>
              <p>Suite 101</p>
              <p>San Francisco, CA 94107</p>
              <p>(415) 555-7890</p>
              <p>info@libertyjusticeadvocate.com</p>
            </div>
            <div className={styles.newsletter}>
              <h2>Join Our Newsletter</h2>
              <div className={styles.inputContainer}>
                <input type="email" placeholder="Enter your email address" />
                <button type="submit">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 2L11 13" />
                    <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h2>Contact Us</h2>
            <form
              action="https://formsubmit.co/info@libertyjusticeadvocate.com"
              method="POST"
            >
              <input type="text" name="name" placeholder="Your Name" required />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                rows="4"
                required
              ></textarea>

              <button type="submit">Send</button>
            </form>
          </div>
        </div>

        <div className={styles.logos}>
          <FaInstagram />
          <FaXTwitter />
          <FaTwitch />
          <FaDiscord />
          <FaLinkedin />
          <FaFacebook />
        </div>
      </div>

      <p>© {currentYear} L & J STALEY YOUNG P.C. | ALL RIGHTS RESERVED |</p>
    </div>
  );
}

export default Last;
